export default __webpack_public_path__ + "static/media/Group -12.6c4f45da.png";